import React, {useContext, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useWindowSize} from "@reach/window-size";
import {ReactComponent as KlashaPinkLogo} from "../../assets/klasha-mobile-icon.svg";
import styles from "./Methods.module.css";
import {Method, MethodKeyType} from "../Method";
import {MobileWrapper} from "../common/MobileWrapper";
import {RoutingContext} from "../../context/Router";
import {acceptedWalletsByCountry} from "../../context/utils";
import currencyToSymbol from "../../currencyMap";

export const Methods = () => {
    const navigate = useNavigate();
    const {width} = useWindowSize();
    const {amount, currency, payData} = useContext(RoutingContext);

    const [currencyMethods, setCurrencyMethods] = useState<MethodKeyType[]>(["card"]);

    useEffect(() => {
        const methods = acceptedWalletsByCountry(payData?.details?.currency, payData.kit);

        if (methods.length > 1 && width > 768) {
            navigate(`/${methods[0]}`);
        } else if (["USD", "ZAR"].includes(currency) && methods.length === 1 && width > 768) {
            navigate("/card");
        }

        setCurrencyMethods(methods);
    }, [currency, navigate, payData.kit, width]);

    const sourceCurrency = payData?.details?.currency;
    const currencySymbol = sourceCurrency ? (currencyToSymbol[sourceCurrency] || sourceCurrency) : '';


    return (
        <MobileWrapper>
            <div className={styles.container}>
                <div className={styles.main}>
                    <div className={styles.head}>
                        <div className={styles.header}>
                            <p>Pay with</p>
                            <div>
                                <KlashaPinkLogo/>
                            </div>
                        </div>
                        <p className={styles.subheader}>
                            Choose a payment method to pay {currencySymbol} {amount}
                        </p>
                    </div>
                    <div className={styles.body}>
                        {currencyMethods.map((method) => (
                            <Method key={method} methodKey={method}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </MobileWrapper>
    );
};
